<template>
  <el-select
    :disabled="readonly"
    :value="valueTitle"
    :clearable="true"
    @clear="clearHandle"
    ref="treeSelect"
  >
    <el-input class="selectInput" placeholder="输入关键字" v-model="filterText">
    </el-input>

    <el-option :value="valueTitle" :label="valueTitle" class="options">
      <el-tree
        id="tree-option"
        ref="selectTree"
        :data="options"
        :props="{
          label: 'GroupName',
        }"
        node-key="GroupId"
        :default-expanded-keys="[value]"
        :filter-node-method="filterNode"
        @node-click="handleNodeClick"
      >
      </el-tree>
    </el-option>
  </el-select>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    GroupFlag: {},
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      GroupList: [],
      filterText: "",
    };
  },
  computed: {
    valueTitle() {
      let GroupId = this.value;
      if (!GroupId) {
        return "";
      }
      let item = this.GroupList.find((r) => r.GroupId == GroupId);
      if (item) {
        return item.GroupName;
      } else {
        return "";
      }
    },
    options() {
      return this.$g.listToTree(this.GroupList, "GroupId", "GroupParent");
    },
  },
  watch: {
    filterText(val) {
      this.$refs.selectTree.filter(val);
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("UGroupinfo/GetList", {
        GroupFlag: this.GroupFlag,
      }).then((r) => {
        this.GroupList = r.Result;
        this.initScroll();
      });
    },
    // 初始化滚动条
    initScroll() {
      this.$nextTick(() => {
        let scrollWrap = document.querySelectorAll(
          ".el-scrollbar .el-select-dropdown__wrap"
        )[0];
        let scrollBar = document.querySelectorAll(
          ".el-scrollbar .el-scrollbar__bar"
        );
        scrollWrap.style.cssText =
          "margin: 0px; max-height: none; overflow: hidden;";
        scrollBar.forEach((ele) => (ele.style.width = 0));
      });
    },
    // 切换选项
    handleNodeClick(node) {
      this.$emit("input", node.GroupId);
      if (!node.children || !node.children.length) {
        //补录选择完选项不能收起
        this.$refs.treeSelect.blur();
        this.filterText = "";
      }
    },
    // 清除选中
    clearHandle() {
      this.$emit("input", "");
      this.clearSelected();
    },
    /* 清空选中样式 */
    clearSelected() {
      let allNode = document.querySelectorAll("#tree-option .el-tree-node");
      allNode.forEach((element) => element.classList.remove("is-current"));
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.GroupName.indexOf(value) !== -1;
    },
  },
};
</script>
<style scoped>
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}

.el-select-dropdown__item.selected {
  font-weight: normal;
}

ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}

.el-tree-node__label {
  font-weight: normal;
}

.el-tree >>> .is-current .el-tree-node__label {
  color: #4bfeff;
  font-weight: 700;
}

.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #4bfeff;
  font-weight: normal;
}

.selectInput {
  padding: 0 5px;
  box-sizing: border-box;
}
</style>